import css from './SubPageHeader.css';
import { Button, Label } from '../widgets';
import { IconVariants } from '../foundations/Icon';
import { Translate } from 'react-localize-redux';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const SubPageHeader = ({
    onGoBack,
    goBackTranslationKey,
    labelTranslationKey,
    labelTextReplace = {},
    className = '',
    rightSection,
}) => {
    return (
        <div className={classNames(css.header, className)}>
            <div className={css.mainContent}>
                <Button
                    onClick={onGoBack}
                    type="link"
                    Icon="chevron-left"
                    iconVariant={IconVariants.LIGHT}
                    className={css.backButton}
                >
                    <Translate id={goBackTranslationKey} />
                </Button>
                <Label
                    text={labelTranslationKey}
                    textReplace={labelTextReplace}
                    className={css.title}
                />
            </div>
            {rightSection}
        </div>
    );
};

SubPageHeader.propTypes = {
    onGoBack: PropTypes.func.isRequired,
    goBackTranslationKey: PropTypes.string.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    labelTextReplace: PropTypes.object,
    className: PropTypes.string,
    rightSection: PropTypes.node,
};

export default SubPageHeader;
